module.exports = __webpack_public_path__ + "static/media/1920-service-2-4-min.53124ffd.jpg";